






















































































import EnterpriseService from '@/services/enterprise/EnterpriseService';
import UserService from '@/services/user/user-service';
import User from '@/datatypes/user';
import Vue from 'vue';
import camelcaseKeysDeep from 'camelcase-keys-deep';

export default Vue.extend({
  data: () => ({
    enterpriseService: new EnterpriseService(),
    userService: new UserService(),
    email: '',
    isAddingAdmin: false,
    users: [] as User[],
  }),

  computed: {
    addingAdmin(): User {
      if (this.users.length === 1) {
        return this.users[0];
      }

      return new User({});
    },
  },
  methods: {
    searchUser() {
      this.userService.list({ email: this.email }).then((response) => {
        this.users = response.data.map((data) => new User(camelcaseKeysDeep(data)));

        if (this.users.length === 0) {
          this.$store.commit('errorMessage', 'User not found.');
        }
      });
    },

    addAdministrator() {
      this.enterpriseService.addGlobalAdministrator(this.addingAdmin).then(() => {
        this.$store.commit(
          'errorMessage',
          'Global administrator add request sent. Please check the owner e-mail.',
        );

        this.isAddingAdmin = false;
        this.users = [];
      }, (error) => {
        this.$store.commit('errorMessage', error.response.data.message);
      });
    },
  },
});
